import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import PopoverHeader from './PopoverHeader'
import { connect } from 'react-redux'
import { Label, ToggleSwitch } from 'wix-style-react'
import { setCustomFieldArray } from 'controllers/logic'
import AssetsSelector from './AssetsSelector'

const Container = styled.div`
  ${props => props.popoverSection === 'assets' && 'height: 26em;'}
  width: 20em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border-radius: 8px;
  box-shadow: 0 4px 10px 8px rgba(175,175,175,0.27);
`
const TextInputContainer = styled.div`
  padding: 1.3em 1.5em 1.3em 1.5em;
`
const Content = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  display: flex;
  flex-direction: column;
`

class VideoScenePopover extends Component {

  componentWillMount () {
    this.props.updatePosition('15%', '45%')
  }

  onChange = (val) => {
    const { app, dispatch, path } = this.props
    let value = () => {
      switch (this.props.value.isTappable) {
        case false:
          return true
        case true:
        default:
          return false
      }
    }
    if (path) {
      let newPath = path.concat('isTappable')
      dispatch(setCustomFieldArray(app.id, newPath, value()))
    }
  }

  renderAssetsGallery () {
    const { app, value } = this.props
    return (
      <AssetsSelector
        isVideo
        appId={app.id}
        currentValue={value}
        {...this.props}
      />
    )
  }

  renderContent () {
    const { popoverSection } = this.props
    switch (popoverSection) {
      case 'assets':
        return this.renderAssetsGallery()
      case 'design':
        return (
          <TextInputContainer>
            <div>
              <Label appearance='T1.1' for='email'>
                Allow tap on video to continue:
              </Label>
              <div><ToggleSwitch checked={this.props.value.isTappable} onChange={e => this.onChange(e.target.value)} /></div>
            </div>
          </TextInputContainer>
        )
    }
  }

  render () {
    const { app, field, closeMyself, popoverSection } = this.props
    // console.log('render video scene popover', this.props.value)
    return (
      <Container
        popoverSection={popoverSection}
      >
        <PopoverHeader
          headingDescriptor='Video Scene Settings'
          onClose={closeMyself}
          app={app}
          helpTooltip=''
          field={field}
        />
        <Content>
          {this.renderContent()}
        </Content>
      </Container>
    )
  }
}

VideoScenePopover.propTypes = {
  closeMyself: PropTypes.func,
  value: PropTypes.object,
  path: PropTypes.array,
  // title: PropTypes.string,
  field: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired,
  updatePosition: PropTypes.func,
  popoverSection: PropTypes.string
}

export default connect()(VideoScenePopover)



// WEBPACK FOOTER //
// ./src/components/editor/popovers/VideoScenePopover.js